<template>
  <div class="clue-module">
    <el-dialog
      :title="mytitle"
      :visible.sync="showUpdate"
      width="1400px"
      :close-on-click-modal="false"
    >
      <div
        class="img-content"
        style="display: flex;height: 600px;justify-content: space-around;"
      >
        <div class="img-content-left" style="width: 376px;">
          <div style="font-weight: bold; margin-bottom: 10px; font-size: 16px;">
            当前海报
          </div>
          <div class="current-poster">
            <img :src="currentImageUrl" style="height: 100%;width: 100%;" />
          </div>
        </div>
        <div class="img-content-middle" style="width: 213px;">
          <div style="font-weight: bold; margin-bottom: 10px; font-size: 16px;">
            *海报上传
          </div>
          <div>
            <el-upload
              class="avatar-uploader"
              :action="addFile"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="font-size: 12px; color: #21B6EA;">
            建议尺寸:1128x1389px,建议大小不超过5mb,建议格式:png
          </div>
        </div>

        <div class="img-content-right" style="width: 376px;">
          <div>海报预览(带模拟二维码)</div>
          <div style="margin:14px 0px ; color: #21B6EA;">生成预览图</div>
          <div style="width: 376px;height: 463px; position: relative;">
            <img
              src="https://servant.lifejingzhi.com/file/jzworker/wx_share/zzy_qrcode.png"
              alt=""
              style="width: 50px;height: 50px; position: absolute;bottom: 20px;right: 28px;"
              v-if="imageUrl"
            />
            <img :src="imageUrl" alt="" style="width: 100%;height: 100%;" />
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="large" @click="cancelShowDialog">关闭</el-button>
        <el-button size="large" type="primary" @click="saveCreate"
          >发布</el-button
        >
      </span>
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import Service from "@/script/api/service";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNotmust,
  validateIdNoOrNull,
  validateNumber
} from "@/script/validator";
import url from "postcss-url";

let vm;
export default {
  data() {
    return {
      showUpdate: false,
      mytitle: "配置海报",
      upLoadImageUrl: "",
      currentImageUrl: "",
      imageUrl: "",
      addFile: Service.addFile + globalData.userInfo.userAccount,
    };
  },
  beforeCreate() {
    vm = this;
  },

  methods: {
    showAddWorkerClue() {
      this.showUpdate = true;
      this.upLoadImageUrl = workercrmapi.$axiosUploadZzyPoster;
      workercrmapi.$ajaxGetZzyPoster().then(res => {
        console.log(res.data.data.imgSrc);
        if (res.data.errno == 0) {
          this.currentImageUrl = res.data.data.imgSrc;
        }
      });
    },
    saveCreate() {
      this.checkImageDimensions(this.imageUrl, 1128, 1389)
        .then(result => console.log(result))
        .catch(error => {
          this.$notify.warning({
            title: "提示",
           message: "图片上传比例有误，可能会被压缩"
            
          });
        });

      this.$confirm("是否覆盖当前海报并发布至招招盈计划？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            imgUrl: this.imageUrl
          };
          workercrmapi.$ajaxUpdateZzyPoster(params).then(res => {
            if (res.data.errno == 0) {
              this.$notify.success({
                title: "成功",
                message: "发布成功！"
              });
              (this.imageUrl = ""), (this.showUpdate = false);
              this.dialogVisible = false;
            } else {
              this.$notify.error({
                title: "失败",
                message: "发布失败，请确认上传文件是否正确"
              });
            }
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "失败",
            message: "发布失败，请确认上传文件是否正确"
          });
        });
    },
   
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data.fileUrl;
    },

    checkImageDimensions(src, desiredWidth, desiredHeight) {
      return new Promise((resolve, reject) => {
        let img = new Image();

        img.onload = () => {
          if (img.width === desiredWidth && img.height === desiredHeight) {
            resolve("图片尺寸符合要求");
          } else {
            reject(
              new Error(
                `图片尺寸不符合要求，期望尺寸为 ${desiredWidth}x${desiredHeight}`
              )
            );
          }
        };

        img.src = src;
      });
    },
    cancelShowDialog() {
      this.showUpdate = false;
      this.imageUrl = "";
      this.dialogVisible = false;
    }
  }
};
</script>
<style>
.el-dialog--center .el-dialog__body {
  padding: 24px 40px 24px 20px !important;
}
.el-dialog__header {
  padding: 20px 20px 10px;
  background-color: #20b6eb !important;
}
.clue-module .el-select {
  width: 100%;
}

.clue-module .el-radio {
  margin-right: 12px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #f2f1f1;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 213px;
  height: 379px;
  line-height: 379px!important;
  text-align: center;
  background: #f2f1f1;
  margin-bottom: 10px;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.demo-image__error .image-slot {
  font-size: 30px;
}
.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}

.current-poster {
  width: 376px;
  height: 463px;
  position: relative;
}
.current-poster::after {
  content: "";
  position: absolute;
  top: 100px;
  right: -60px;
  bottom: 0;
  width: 3px;
  background-color: #999;
  height: 260px;
}
</style>
